module.exports = __webpack_public_path__ + "static/img/sijie.5cd2203.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/sijie.jpg
// module id = vFD0
// module chunks = 0